import {
  FormControl,
  FormControlProps,
  FormErrorMessage,
  FormLabel,
} from "@chakra-ui/react";
import { PropsWithChildren, ReactNode } from "react";

export interface WithFormControlProps extends Omit<FormControlProps, "label"> {
  label?: ReactNode;
  errorMessage?: ReactNode;
}

export const WithFormControl = ({
  children,
  label,
  errorMessage,
  ...formControlProps
}: PropsWithChildren<WithFormControlProps>): JSX.Element => (
  <FormControl {...formControlProps}>
    {Boolean(label) && <FormLabel>{label}</FormLabel>}
    {children}
    <FormErrorMessage>{errorMessage}</FormErrorMessage>
  </FormControl>
);
